import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { Component, effect, inject, OnInit, Signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { HeaderComponent } from '../../components/header/header.component';
import { StepperComponent } from '../../components/stepper/stepper.component';
import { NavigationStart, Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import TYPES from '../../constants/types';
import { LogService } from '../../services/log.service';
import { TextAreaComponent } from "../../components/text-area/text-area.component";
import { UntypedFormControl } from '@angular/forms';
import { Log } from '../../models/log';
import { filter } from 'rxjs';

@Component({
  selector: 'app-reason',
  imports: [
    HeaderComponent,
    StepperComponent,
    ButtonComponent,
    TranslatePipe,
    MatSnackBarModule,
    DialogModule,
    TextAreaComponent
],
  templateUrl: './reason.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reason.component.scss'
})
export class ReasonComponent {
  BUTTON_TYPES:any;
  step: Signal<StepperComponent | undefined> = viewChild<StepperComponent>('stepper');

  whatHappenedControl: UntypedFormControl;

  snackBar:MatSnackBar = inject(MatSnackBar);
  dialog: Dialog = inject(Dialog);
  translate: TranslateService = inject(TranslateService);

  constructor(
    private router:Router,
    private logService: LogService<Log>,
  ){
    effect( ()=> {
      this.step()?.steps()[3].nativeElement.classList.add('active');
    });

    this.whatHappenedControl = new UntypedFormControl(this.logService.log().what_happened ?? '');

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  next(){
    this.logService.log.update( 
      (current) => {
        return {
          ...current,
          what_happened: this.whatHappenedControl.value,
        }
      }
    );
    
    // this.router.navigate(['/did-think'], { replaceUrl: true });
    this.router.navigate(['/did-think']);
  }

  back(){
    // this.router.navigate(['/body-reaction'], { replaceUrl: true });
    history.back();
  }

  close(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'log-close-dialog.alert_title',
        message: 'log-close-dialog.alert_message'
      },
    });

    dialogRef.closed.subscribe((result:any)  => {
      if(result?.action === 'continue'){
        this.logService.canAccessMindLogRegister.set(false);
        this.router.navigate(['/home'], { replaceUrl: true });
      }
    });   
  }

}
